var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLoseIcon = function SvgLoseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ACB3BE",
    fillRule: "evenodd",
    d: "m13.409 12 4.295-4.287a1.003 1.003 0 0 0-1.418-1.42L12 10.59 7.714 6.294a1.003 1.003 0 1 0-1.418 1.419l4.295 4.286-4.295 4.287a1 1 0 0 0 0 1.418.999.999 0 0 0 1.418 0L12 13.408l4.286 4.296a.999.999 0 0 0 1.418 0 1 1 0 0 0 0-1.418l-4.295-4.287Z",
    clipRule: "evenodd"
  })));
};
export default SvgLoseIcon;